import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';
import { injectIntl } from 'react-intl';

import ChangePlanPage from '../../../components/ChangePlan/motorplay';
import { requestAsync, updateInitialExchangeByDeviceCountry, hiddenCouponInput } from '../../../queries/actions';
import { updatePlanSubscription } from '../../../queries/subscription';
import {
  selectActivePlanSubscription, selectProducts,
  selectProductsPlan,
} from '../../../queries/selectors/products';
import { selectSubscriberConfig, selectSubscriptionList } from '../../../queries/selectors/bootstrap';
import { selectCurrentContentFichaPath } from '../../../queries/selectors/contents';
import { selectUserData } from '../../../queries/selectors/user';
import withMembershipGuard from '../../withMembershipGuard';
import withMembershipPurchased from '../../withMembershipPurchased';
import withAuthGuard from '../../withAuthGuard';
import withPaymentStatus from '../../withPaymentStatus';
import { selectClient, selectProductToUpgrade } from '../../../global-selectors';
import { selectAllSubPaymentMethodsConfig, selectCurrentPaymentMethod } from '../../../queries/selectors/payment';
import { setIgnoreRedirectInSubscription } from '../../../queries/actions/subscriber';
import { addProduct, cleanOrder } from '../../../queries/actions/shoppingCart';

const mapStateToProps = state => ({
  userPlan: selectActivePlanSubscription(state),
  plans: selectProductsPlan(state),
  products: selectProductsPlan(state),
  allProducts: selectProducts(state),
  path: selectCurrentContentFichaPath(state),
  subscriptions: selectSubscriptionList(state),
  methodId: selectCurrentPaymentMethod(state),
  user: selectUserData(state),
  client: selectClient(state),
  productToUpgradeId: selectProductToUpgrade(state),
  subscriber: selectSubscriberConfig(state),
  subPaymentMethods: selectAllSubPaymentMethodsConfig(state),
});

const mapDispatchToProps = (
  (dispatch) => bindActionCreators({
    updatePlanSubscription: (data) => requestAsync(updatePlanSubscription, data),
    updateInitialExchangeByDeviceCountry: (payload) => updateInitialExchangeByDeviceCountry(payload),
    setIgnoreRedirect: payload => setIgnoreRedirectInSubscription(payload),
    addProduct: payload => addProduct(payload),
    cleanOrder: () => cleanOrder(),
    hiddenCouponInput: (data) => hiddenCouponInput(data),
  }, dispatch)
);

export default compose(
  withAuthGuard({ toLoginURL: true }),
  injectIntl,
  withMembershipGuard,
  withPaymentStatus,
  withMembershipPurchased,
  connect(mapStateToProps, mapDispatchToProps)
)(ChangePlanPage);
